var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.isSecondAuthPopupOpen)?_c('auth-second-popup',{attrs:{"second-auth-data":_vm.secondAuthData},on:{"completeSecondAuth":_vm.completeSecondAuth,"closePopup":_vm.closePopup}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }